module.exports = __webpack_public_path__ + "static/media/following-icon.fd4ecb66.png";